module.exports = __webpack_public_path__ + "static/media/fig_20b.45e402db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_20b.jpg
// module id = 655
// module chunks = 0